module.exports = __webpack_public_path__ + "static/media/logo.8b7875f0.png";